import cx from "classnames";
// import PropTypes from 'prop-types'
import { MusicHallItemStyled } from "./styled";
import { IMG_PATH } from "utils/constants/imgPath";
import { useTranslation } from "react-i18next";
import { Buttons, Displays } from "components";

const MusicHallItem = ({
  theme_standard,
  cover_img,
  name_en,
  name_th,
  pricing,
  short_description_en,
  short_description_th,
  onBooking,
  onClickDetail,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { i18n, t } = useTranslation(["common"]);
  return (
    <MusicHallItemStyled className={customClass}>
      <div className="content_block" onClick={onClickDetail}>
        <div className="musichall_img">
          <Displays.ImageSmooth
            src={
              cover_img
                ? IMG_PATH + cover_img
                : "/assets/images/mockups/mockup-item-hall.jpg"
            }
            alt="music hall"
            aspectRatio="360 / 240"
          />
        </div>
        <div className="musichall_inblock">
          <div className="musichall_M1">
            {i18n.language === "en" ? name_en : name_th}
          </div>
          <div className="musichall_price">
            {pricing.hourly_rate} THB/Hour.{" "}
          </div>
          <div className="musichall_detail">
            {i18n.language === "en"
              ? short_description_en
              : short_description_th}
          </div>
        </div>
      </div>
      <div className="btn_book_now">
        <Buttons.BgStandard
          label={t("BOOK NOW", { ns: "common" })}
          onClick={onBooking}
        />
      </div>
    </MusicHallItemStyled>
  );
};

MusicHallItem.propTypes = {};

export default MusicHallItem;
